import { Link } from "react-router-dom";

const Blogs = () => {
  function openTab() {
    window.open('https://geocities.ws/ommauryasir/react-js/');
  }
  function openTab1() {
    window.open('https://geocities.ws/ommauryasir/angular-js/');
  }
  return (
    <>
    <h1>Notes to Start learning</h1> 
    <h2>react js tutorials</h2>
    
    <li  className="nav-item">
          <Link onClick={openTab}>Click to Download React js Notes</Link>
          </li>

          <h2>Angular js tutorials</h2>
    
          <li  className="nav-item">
          <Link onClick={openTab1}>Click to Download Angular js Notes</Link>
          </li>
    </>
  
  
  
  );

};

export default Blogs;